export const RMS_GET_APPLICANT_BONDS_REQUEST =
  'RMS_GET_APPLICANT_BONDS_REQUEST';
export const RMS_GET_APPLICANT_BONDS_SUCCESS =
  'RMS_GET_APPLICANT_BONDS_SUCCESS';
export const RMS_GET_APPLICANT_BONDS_FAILED = 'RMS_GET_APPLICANT_BONDS_FAILED';

export const RMS_RESET_APPLICANT_BONDS = 'RMS_RESET_APPLICANT_BONDS';
